import { gql } from '@apollo/client';

export const SEARCH_SUPPLIERS_QUERY = gql`
  query SearchSuppliers(
    $keywords: String!
    $limit: Int = 30
    $filter: SupplierSearchFilter
  ) {
    supplierSearch(
      first: $limit
      query: { keywords: $keywords, filter: $filter }
    ) {
      ...UsersPageSearchSupplierConnectionFragment
      __typename
    }
  }

  fragment UsersPageSearchSupplierConnectionFragment on SearchSupplierConnection {
    edges {
      ...UsersPageSupplierSearchEdgeFragment
      __typename
    }
    __typename
  }

  fragment UsersPageSupplierSearchEdgeFragment on SupplierSearchEdge {
    cursor
    node {
      ...UsersPageSearchSupplierFragment
      __typename
    }
    __typename
  }

  fragment UsersPageSearchSupplierFragment on Supplier {
    id
    name
    __typename
  }
`;
